import { AffectedStaffQuestionnaire } from '../../../lib/types/models/affected-staff-questionnaire/affected-staff-questionnaire'
import { AffectedStaffQuestionnaireInput } from '../../../lib/types/models/affected-staff-questionnaire/affected-staff-questionnaire-input'
import { TravelExpenseInput } from '../../../lib/types/models/travel-expenses/travel-expenses'

export const mapAffectedStaffQuestionnaireToInput = (
  questionnaire: AffectedStaffQuestionnaire
): AffectedStaffQuestionnaireInput => {
  return {
    personalityTraits: questionnaire.personalityTraits,
    hasReligiousAffiliation: questionnaire.hasReligiousAffiliation,
    otherReligiousAffiliation: questionnaire.otherReligiousAffiliation,
    interests: questionnaire.interests,
    willingToStayWithDifferentEthnicBackground:
      questionnaire.willingToStayWithDifferentEthnicBackground,
    isInGoodHealth: questionnaire.isInGoodHealth,
    hasAsthma: questionnaire.hasAsthma,
    asthmaSeverity: questionnaire.asthmaSeverity,
    hasAllergies: questionnaire.hasAllergies,
    allergyType: questionnaire.allergyType,
    isSmoker: questionnaire.isSmoker,
    agreesToFamilyLifeStyle: questionnaire.agreesToFamilyLifeStyle,
    otherInformationInEnglish: questionnaire.otherInformationInEnglish,
    hasDriversLicense: questionnaire.hasDriversLicense,
    drivesRegularly: questionnaire.drivesRegularly,
    hostFamilyLetter: questionnaire.hostFamilyLetter,
    hasMedicalAuthorization: questionnaire.hasMedicalAuthorization,

    hobbies: questionnaire.hobbies.map((hobby) => hobby.name),
    familyImages: questionnaire.familyImages ?? undefined
  }
}

export const getAffectedStaffQuestionnaireBasedOnHostFamily = (
  questionnaire: AffectedStaffQuestionnaireInput,
  hasHostFamily: boolean
): AffectedStaffQuestionnaireInput => {
  const { familyImages, hostFamilyLetter, ...rest } = questionnaire

  return hasHostFamily ? { ...rest, familyImages, hostFamilyLetter } : rest
}

export const isEmptyRow = (v: TravelExpenseInput) =>
  !v.date && !v.details?.trim() && (v.amount == null || Number.isNaN(v.amount))
